<template>
  <div class="distribution-chart-page">
    <el-card class="filter-card" shadow="never">
      <el-form label-position="top" size="small">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8" :lg="4">
            <el-form-item label="货品名称">
              <el-select v-model="form.tplId" style="width: 100%" @change="selectGri">
                <el-option v-for="item in griList" :key="item.tplId" :label="item.griName + '(GRI:' + item.griCode + ')'" :value="item.tplId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="4">
            <el-form-item label="制成分类">
              <el-select v-model="form.category" style="width: 100%" @change="selectProcess">
                <el-option v-for="item in processList" :key="item.tplProcessId" :label="item.processName" :value="item.tplProcessId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="4">
            <el-form-item label="分析指标">
              <el-select v-model="form.factorId" style="width: 100%" @change="selectFactor">
                <el-option v-for="item in factorList" :key="item.tplFactorId" :label="item.factorName" :value="item.tplFactorId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="4">
            <el-form-item label="参数">
              <el-select v-model="form.paramId" :disabled="!paramList.length" clearable style="width: 100%">
                <el-option v-for="item in paramList" :key="item.tplParamId" :label="item.paramName" :value="item.tplParamId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="4">
            <el-form-item label="标准范围">
              <div class="range-inputs">
                <el-input :value="standardFrom" disabled placeholder=""></el-input>
                <span>-</span>
                <el-input :value="standardTo" disabled placeholder=""></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="4">
            <el-form-item label="采样点数 (n)">
              <el-input v-model="form.samplePoints" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16" class="vendor-row">
          <el-col :xs="24" :lg="12">
            <div class="vendor-panel base-panel">
              <div class="panel-title"><i class="el-icon-flag"></i> 基准分析对象</div>
              <el-row :gutter="16">
                <el-col :xs="24" :sm="10">
                  <el-form-item label="供应商选择">
                    <el-select v-model="form.basePlantCode" style="width: 100%">
                      <el-option v-for="item in supplierList" :key="item.code" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="14">
                  <el-form-item label="生产批次/时间">
                    <div class="date-range">
                      <el-date-picker v-model="form.baseDateFrom" type="date" value-format="yyyy-MM-dd" placeholder="开始日期" style="width: 100%"></el-date-picker>
                      <span>至</span>
                      <el-date-picker v-model="form.baseDateTo" type="date" value-format="yyyy-MM-dd" placeholder="结束日期" style="width: 100%"></el-date-picker>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :xs="24" :lg="12">
            <div class="vendor-panel compare-panel">
              <div class="panel-title">
                <el-checkbox v-model="form.contrast">开启供应商对比</el-checkbox>
              </div>
              <el-row :gutter="16" :class="{ 'disabled-content': !form.contrast }">
                <el-col :xs="24" :sm="10">
                  <el-form-item label="对比供应商">
                    <el-select v-model="form.contrastPlantCode" :disabled="!form.contrast" style="width: 100%">
                      <el-option v-for="item in supplierList" :key="item.code" :label="item.name" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="14">
                  <el-form-item label="生产批次/时间">
                    <div class="date-range">
                      <el-date-picker v-model="form.contrastDateFrom" type="date" value-format="yyyy-MM-dd" placeholder="开始日期" :disabled="!form.contrast" style="width: 100%"></el-date-picker>
                      <span>至</span>
                      <el-date-picker v-model="form.contrastDateTo" type="date" value-format="yyyy-MM-dd" placeholder="结束日期" :disabled="!form.contrast" style="width: 100%"></el-date-picker>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>

        <div class="action-row">
          <el-button type="primary" size="mini" @click="generateAnalysis">分布图分析</el-button>
          <el-button type="primary" size="mini" :disabled="!analysis" @click="exportData">导出</el-button>
          <el-button type="primary" size="mini" @click="resetForm">重置</el-button>
        </div>
      </el-form>
    </el-card>

    <el-card class="chart-card" shadow="never">
      <div slot="header" class="card-header">
        <span class="title">{{ analysis ? analysis.chartTitle : '产品数据正态分布图' }}</span>
      </div>

      <div v-if="analysis" class="insight-summary" :class="{ 'compare-mode': analysis.compare }">
        <div class="insight-stats">
          <div class="insight-stat">
          <el-tag size="mini" type="primary">基准</el-tag>
          <span><strong>{{ analysis.base.plantName }}：</strong>n={{ analysis.base.n }}，均值μ={{ analysis.base.avg }}{{ analysis.unit }}，标准差σ={{ analysis.base.stdev }}{{ analysis.unit }}，范围{{ analysis.base.standardRange || "-" }}</span>
          </div>
          <div v-if="analysis.compare" class="insight-stat">
          <el-tag size="mini" type="danger">对比</el-tag>
          <span><strong>{{ analysis.compare.plantName }}：</strong>n={{ analysis.compare.n }}，均值μ={{ analysis.compare.avg }}{{ analysis.unit }}，标准差σ={{ analysis.compare.stdev }}{{ analysis.unit }}，范围{{ analysis.compare.standardRange || "-" }}</span>
          </div>
        </div>
<!--        <div v-if="analysis.compare" class="insight-conclusion">-->
<!--          中心偏移：供应商{{ analysis.compare.vendorName }}的{{ analysis.factorName }}均值{{ analysis.meanDirection }}{{ analysis.meanDifference }}{{ analysis.unit }}，波动{{ analysis.deviationDirection }}{{ analysis.deviationDifference }}%-->
<!--        </div>-->
      </div>

      <div ref="chart" class="chart-container"></div>
    </el-card>
  </div>
</template>

<script>

import echarts from "echarts";
import moment from "moment";
import { fileService } from "@/api/common/file-utils";
import ppmApi from "@/api/productionProcessMonitoring/index";
import processApi from "@/api/Process/index";

export default {
  name: "DistributionChart",
  data() {
    return {
      chart: null,
      analysis: null,
      griList: [],
      processList: [],
      supplierList: [],
      form: {
        tplId: "",
        category: "",
        factorId: "",
        paramId: "",
        samplePoints: 200,
        basePlantCode: "",
        baseDateFrom: moment().subtract(3, 'months').format('YYYY-MM-DD 00:00:00'),
        baseDateTo: moment().format("YYYY-MM-DD 23:59:59"),
        contrast: false,
        contrastPlantCode: "",
        contrastDateFrom: moment().subtract(3, 'months').format('YYYY-MM-DD 00:00:00'),
        contrastDateTo: moment().format("YYYY-MM-DD 23:59:59")
      }
    };
  },
  computed: {
    selectedProcess() {
      return this.processList.find(process => process.tplProcessId === this.form.category) || null;
    },
    factorList() {
      return this.selectedProcess && Array.isArray(this.selectedProcess.factors)
        ? this.selectedProcess.factors
        : [];
    },
    currentFactor() {
      return this.factorList.find(factor => factor.tplFactorId === this.form.factorId) || {};
    },
    paramList() {
      return this.currentFactor && Array.isArray(this.currentFactor.params)
        ? this.currentFactor.params
        : [];
    },
    currentParameter() {
      return this.paramList.find(param => param.tplParamId === this.form.paramId) || {};
    },
    standardFrom() {
      return this.currentParameter && this.currentParameter.standardType === "RANGE" ? this.currentParameter.standard.split("-")[0] : "";
    },
    standardTo() {
      return this.currentParameter && this.currentParameter.standardType === "RANGE" ? this.currentParameter.standard.split("-")[1] : "";
    }
  },
  watch: {
    "form.category"() {
      this.form.factorId = this.factorList.length ? this.factorList[0].tplFactorId : "";
    },
    currentFactor(factor) {
      const params = factor && Array.isArray(factor.params) ? factor.params : [];
      // this.form.paramId = params.length ? params[0].tplParamId  : "";
    }
  },
  mounted() {
    this.chart = echarts.init(this.$refs.chart);
    window.addEventListener("resize", this.resizeChart);
    this.getTemplateList();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeChart);
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    async getTemplateList() {
      let request = {
        status: "ACTIVE",
        // templateType: "",
        isLatest: 1,
        pageNum: -1,
        pageSize: -1
      };
      let res = await ppmApi.getProcessTemplateList(request);
      if(res.code == 200) {
        this.griList = res.data.records?res.data.records:[];
        this.form.tplId = this.griList.length ? this.griList[0].tplId : "";
        this.selectGri(this.form.tplId);
        this.getSupplierList(this.form.tplId);
      }
    },
    async getSupplierList(val) {
      let res = await ppmApi.getSupplierListByTemplateId({tplId: val});
      if(res.code == 200) {
        this.supplierList = res.data||[];
        this.form.basePlantCode = this.supplierList.length ? this.supplierList[0].code : "";
        this.form.contrastPlantCode = this.supplierList.length ? this.supplierList[0].code : "";
      }
    },
    // 选择GRI
    async selectGri(val) {
      let res = await processApi.viewTemplate(val);
      if(res.code == 200) {
        this.processList = res.data.processes?res.data.processes:[];
        this.form.category = this.processList.length?this.processList[0].tplProcessId:"";
        const firstProcess = this.processList[0];
        const firstFactors = firstProcess && Array.isArray(firstProcess.factors) ? firstProcess.factors : [];
        this.form.factorId = firstFactors.length ? firstFactors[0].tplFactorId : "";
        this.form.paramId = "";
        this.getSupplierList(val);      }
    },
    // 选择制成
    selectProcess(val) {
      let process = this.processList.find(item => item.tplProcessId === val);
      let factors = process && Array.isArray(process.factors) ? process.factors : [];
      this.form.factorId = factors.length ? factors[0].tplFactorId : "";
      this.form.paramId = "";
    },
    // 选择指标
    selectFactor(val) {
      this.form.factorId = val;
      let factor = this.factorList.find(item => item.tplFactorId === val);
      // let params = factor && Array.isArray(factor.params) ? factor.params : [];
      // this.form.paramId = params.length ? params[0].tplParamId : "";
      this.form.paramId = "";
    },
    async generateAnalysis() {
      if (!this.form.factorId) {
        this.$message.warning("请选择分析指标");
        return;
      }
      const samplePoints = Number(this.form.samplePoints);
      if (!Number.isInteger(samplePoints) || samplePoints < 2) {
        this.$message.warning("采样点数必须是>=2的整数");
        return;
      }

      const gri = this.griList.find(griItem => griItem.tplId === this.form.tplId);
      const request = {
        tplId: gri ? gri.tplId : "",
        category: this.form.category,
        factorId: this.form.factorId,
        paramId: this.form.paramId,
        samplePoints,
        basePlantCode: this.form.basePlantCode,
        baseDateFrom: this.form.baseDateFrom,
        baseDateTo: this.form.baseDateTo,
        contrast: this.form.contrast,
        contrastPlantCode: this.form.contrast ? this.form.contrastPlantCode : "",
        contrastDateFrom: this.form.contrast ? this.form.contrastDateFrom : "",
        contrastDateTo: this.form.contrast ? this.form.contrastDateTo : ""
      };
      let res = await ppmApi.getProcessDataDistribution(request);
      if(res.code == 200) {
        let analysis = this.buildAnalysis(res.data);
        if (!analysis) {
          this.$message.warning("暂无可展示的分布图数据");
          return;
        }
        this.analysis = analysis;
        this.$nextTick(this.renderChart);
      }
    },
    buildAnalysis(data) {
      if (!data || !data.baseChartDetail || !data.baseChartDetail.chartData) return null;
      const base = data.baseChartDetail;
      const axisTitle = data.axisTitle;
      const chartTitle =data.chartTitle;
      const compare = this.form.contrast ? data.contrastChartDetail : null;
      if (this.form.contrast && (!compare || !compare.chartData)) return null;
      const gri = this.griList.find(griItem => griItem.tplId === this.form.tplId);
      const griName = gri ? gri.griName : "";
      const categoryName = this.selectedProcess ? this.selectedProcess.processName : "";
      const factorName = this.currentFactor.factorName ? this.currentFactor.factorName : "";
      const parameterName = this.currentParameter ? this.currentParameter.paramName : "";
      const unit = this.currentParameter ? this.currentParameter.uom || "" : "";
      const title = `${griName} - ${categoryName} - ${factorName}${this.currentFactor.inputMode === 'TABLE' && parameterName ? ` - ${parameterName}` : ""} 分布对比`;
      return {
        axisTitle,
        chartTitle,
        title,
        unit,
        factorName,
        base,
        compare
      };
    },
    renderChart() {
      if (!this.chart || !this.analysis) return;

      const analysis = this.analysis;
      const toSeries = (detail, label, color, areaOpacity, lineType) => {
        const data = Object.keys(detail.chartData)
          .map(value => [Number(value), detail.chartData[value]])
          .sort((a, b) => a[0] - b[0]);
        return {
          name: `${detail.plantName} (${label})`,
          type: "line",
          smooth: true,
          symbol: "none",
          data,
          areaStyle: { opacity: areaOpacity, color },
          lineStyle: { color, width: 2, type: lineType }
        };
      };
      const series = [toSeries(analysis.base, "基准", "#0ea5e9", 0.15, "solid")];
      if (analysis.compare) {
        series.push(toSeries(analysis.compare, "对比", "#f43f5e", 0.05, "dashed"));
      }
      const samplePoints = Number(this.form.samplePoints);

      this.chart.setOption({
        color: ["#0ea5e9", "#f43f5e"],
        tooltip: {
          trigger: "axis",
          formatter: params => {
            const lines = params.map(param =>
              `${param.marker} ${param.seriesName}: 密度 ${param.value[1]}`
            );
            return `${params[0].axisValue} ${analysis.unit}<br/>${lines.join("<br/>")}`;
          }
        },
        legend: { top: 0, right: 10 },
        grid: { left: "3%", right: "4%", bottom: "5%", top: "15%", containLabel: true },
        xAxis: {
          type: "value",
          min: "dataMin",
          max: "dataMax",
          splitNumber: Math.min(50, Math.max(2, Math.ceil(Math.sqrt(samplePoints)))),
          name: analysis.axisTitle,
          nameLocation: "middle",
          nameGap: 40,
          axisLabel: { rotate: 90 },
          boundaryGap: false
        },
        yAxis: {
          type: "value",
          name: "概率密度",
          splitLine: { lineStyle: { type: "dashed", color: "#e2e8f0" } }
        },
        series
      }, true);
    },
    resetForm() {
      this.form = {
        tplId: "",
        category: "",
        factorId: "",
        paramId: "",
        samplePoints: 200,
        basePlantCode: "",
        baseDateFrom: moment().subtract(3, 'months').format('YYYY-MM-DD 00:00:00'),
        baseDateTo: moment().format("YYYY-MM-DD 23:59:59"),
        contrast: false,
        contrastPlantCode: "",
        contrastDateFrom: moment().subtract(3, 'months').format('YYYY-MM-DD 00:00:00'),
        contrastDateTo: moment().format("YYYY-MM-DD 23:59:59")
      };
      this.analysis = null;
      if (this.chart) this.chart.clear();
    },
    exportData() {
      ppmApi.exportProcessDataDistribution(this.form).then(res => {
        fileService.respToFile(res, "制成数据分布图.xlsx");
      })
    },
    resizeChart() {
      if (this.chart) this.chart.resize();
    }
  }
};
</script>

<style scoped>
.distribution-chart-page {
  padding: 16px;
  background: #f5f7fa;
  min-height: 100%;
  color: #303133;
}

.filter-card,
.chart-card {
  margin-bottom: 16px;
  border-color: #ebeef5;
  border-radius: 4px;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  color: #303133;
  font-size: 15px;
  font-weight: 600;
}

.title i {
  margin-right: 6px;
  color: #e6a23c;
}

.chart-card ::v-deep .el-card__header {
  padding: 14px 20px;
}

.filter-card ::v-deep .el-card__body {
  padding: 18px 20px 14px;
}

.filter-card ::v-deep .el-form-item {
  margin-bottom: 14px;
}

.filter-card ::v-deep .el-form-item__label {
  padding-bottom: 4px;
  line-height: 20px;
  color: #606266;
}

.range-inputs,
.date-range {
  display: flex;
  align-items: center;
  gap: 8px;
}

.range-inputs > .el-input {
  min-width: 0;
}

.range-inputs > span,
.date-range > span {
  flex: none;
  color: #909399;
}

.vendor-row {
  padding-top: 12px;
  border-top: 1px dashed #ebeef5;
}

.vendor-panel {
  height: 100%;
  padding: 14px 16px 0;
  border: 1px solid #ebeef5;
  border-top-width: 3px;
  border-radius: 4px;
}

.base-panel {
  border-top-color: #ffc72c;
  background: #fffbeb;
}

.compare-panel {
  border-top-color: #f56c6c;
  background: #fff9f9;
}

.panel-title {
  margin-bottom: 8px;
  color: #b45309;
  font-size: 14px;
  font-weight: 600;
}

.compare-panel .panel-title {
  color: #f56c6c;
}

.compare-panel .panel-title ::v-deep .el-checkbox__label {
  color: #f56c6c;
  font-size: 14px;
  font-weight: 600;
}

.disabled-content {
  opacity: 0.55;
}

.action-row {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f2f6fc;
}

.insight-summary {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  padding: 12px 14px;
  border: 1px solid #e4e7ed;
  border-left: 4px solid #e6a23c;
  border-radius: 4px;
  background: #f8fafc;
  font-size: 13px;
}

.insight-summary.compare-mode {
  border-color: #fde2e2;
  border-left-color: #f56c6c;
  background: #fff9f9;
}

.insight-stats {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.insight-stat {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #606266;
  line-height: 1.6;
  min-width: 0;
}

.insight-stat strong {
  color: #303133;
}

.insight-conclusion {
  padding-top: 8px;
  border-top: 1px dashed #ebeef5;
  color: #c45656;
  font-weight: 600;
}

.chart-container {
  width: 100%;
  height: 400px;
}

@media (max-width: 768px) {
  .distribution-chart-page {
    padding: 10px;
  }

  .vendor-panel {
    margin-bottom: 12px;
  }

  .action-row {
    flex-wrap: wrap;
  }

  .insight-stats {
    align-items: flex-start;
    flex-direction: column;
  }

  .insight-stat {
    align-items: flex-start;
  }
}
</style>
